import { render, staticRenderFns } from "./research_report.vue?vue&type=template&id=19fbedb8&"
import script from "./research_report.vue?vue&type=script&lang=ts&"
export * from "./research_report.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports